<template>
  <v-icon
    v-if="iconFromValue"
    :class="{ 'bm-grid-clickable': clickable }"
    v-on="
      clickable
        ? {
            click: (event) => {
              event.stopPropagation();
              $emit('edit', event);
            },
          }
        : {}
    "
    >{{ iconFromValue }}</v-icon
  >
  <div v-else>-</div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref, watch } from "vue";

export default defineComponent({
  name: "DataCellBoolean",
  props: {
    // If the context is appropriate the row item data this renderer is rendering a cell for.
    item: {
      default: () => undefined,
      required: false,
    },
    value: {
      required: true,
    },
  },
  setup(props, context) {
    // Need to make context reactive to track reactivity on listeners
    const reactiveContext = reactive(context);
    const clickable = ref(false);

    watch(
      reactiveContext,
      (ctx) => {
        // Deprecated - not available in Vue 3. Event listeners in parent
        // component need to be passed in with props through v-bind, not
        // through v-on, and then accessed with context.attrs
        clickable.value = !!ctx.listeners.edit;
      },
      { deep: true, immediate: true }
    );

    return {
      iconFromValue: computed(() => {
        if (typeof props.value !== "boolean") {
          return null;
        }
        return props.value ? "check" : "clear";
      }),
      clickable,
    };
  },
});
</script>
